export const MIME_TYPES = {
  pdf: 'application/pdf',
  doc: 'application/msword',
  docx: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  png: 'image/png',
  gif: 'image/gif',
  txt: 'text/plain',
  zip: 'application/zip',
};

export const getMimeTypeFromExtension = fileName => {
  const extension = fileName
    ?.split('.')
    .pop()
    ?.toLowerCase();
  return MIME_TYPES[extension] || 'application/octet-stream';
};

export const getTimestampForFileName = () => {
  const now = new Date();
  const pad = value => String(value).padStart(2, '0');

  const day = pad(now.getDate());
  const month = pad(now.getMonth() + 1);
  const year = now.getFullYear();
  const hours = pad(now.getHours());
  const minutes = pad(now.getMinutes());

  return `${day}-${month}-${year} ${hours}:${minutes}`;
};

export const blobToDataUrl = blob =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

export const getFileNameFromContentDisposition = header => {
  if (!header) {
    return null;
  }

  const marker = "filename*=utf-8''";
  const headerLower = header.toLowerCase();
  const utf8Index = headerLower.indexOf(marker);

  if (utf8Index !== -1) {
    let filename = header.substring(utf8Index + marker.length);

    const semicolonIndex = filename.indexOf(';');
    if (semicolonIndex !== -1) {
      filename = filename.substring(0, semicolonIndex);
    }

    return decodeURIComponent(filename.trim());
  }

  const simpleMatch = header.match(/filename="?([^";]+)"?/i);
  if (simpleMatch?.[1]) {
    return simpleMatch[1];
  }

  return null;
};

export const getFileNameFromUrl = url => {
  try {
    const parsedUrl = new URL(url);
    const pathName = parsedUrl.pathname;
    const parts = pathName.split('/').filter(Boolean);
    return parts[parts.length - 1] || null;
  } catch {
    return null;
  }
};
